export default "__VITE_ASSET__C5r0TbwV__"